import React from 'react'
import { CalendarExercises as C } from '../../features/calendar/CalendarExercise'
import { RouteProps } from '../../routes/AppRouter'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremeLogoMain.svg'
import style from '../layout/Main.module.css'

type CalendarExerciseProps = {
  id?: string
  selectedDate?: Date
} & RouteProps

export function CalendarExercise(props: CalendarExerciseProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const state: CalendarExerciseProps = props.location?.state as CalendarExerciseProps

  return (
    <>
      <C id={props.id} selectedDate={state?.selectedDate} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
